import * as React from 'react';
import { connect } from 'react-redux';

import { FromToControl } from '../../../../common/components/from_to_control';
import { IAppState, Dispatch } from '../../../../common/state';
import { changeMaxCeilingHeight, changeMinCeilingHeight } from '../../../state/advanced/ceiling_height';
import { InlineLabel, InlineParam, Row } from '../markup';

interface ICeilingHeightProps {
  ceilingHeight: { gte?: number; lte?: number };
  onMinCeilingHeightChanged(value: number): void;
  onMaxCeilingHeightChanged(value: number): void;
}

const ceilingHeight: React.StatelessComponent<ICeilingHeightProps> = props => (
  <Row title="Высота потолков">
    <InlineParam>
      <FromToControl
        from={{
          onValueChange: props.onMinCeilingHeightChanged,
          value: props.ceilingHeight.gte,
        }}
        to={{
          onValueChange: props.onMaxCeilingHeightChanged,
          value: props.ceilingHeight.lte,
        }}
      />
    </InlineParam>
    <InlineLabel>м</InlineLabel>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    ceilingHeight: (state.filters.jsonQuery.ceiling_height && state.filters.jsonQuery.ceiling_height.value) || {},
  }),
  (dispatch: Dispatch) => ({
    onMinCeilingHeightChanged: (value: number) => {
      dispatch(changeMinCeilingHeight(value));
    },
    onMaxCeilingHeightChanged: (value: number) => {
      dispatch(changeMaxCeilingHeight(value));
    },
  }),
)(ceilingHeight);
